import CollaboratorsListContainer from 'src/container/list-collaborators'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
const CollaboratorList = props => {
  const { classes } = props
  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Members</Typography>
      <CollaboratorsListContainer />
    </div>
  )
}

export default withStyles(styles)(CollaboratorList)
